import { useMutation, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { StudioDetails } from '../model/types';

export const createStudioAPI = async (code: string) => {
  const resp = await baseAPI.post<{ studio: StudioDetails; token: string }>(
    '/studios/auth',
    {
      code: code,
    },
  );
  return resp.data;
};

export const useCreateStudioAPI = (code?: string) => {
  return useQuery({
    queryKey: [KEYS.AUTH, code],
    queryFn: () => createStudioAPI(code ?? 'should not trigger a request'),
    enabled: !!code,
  });
};

export const useCreateStudioMutation = () => {
  return useMutation({
    mutationFn: async (code: string) => {
      const response = await baseAPI.post<StudioDetails>('/studios/auth', {
        code: code,
      });
      return response.data;
    },
  });
};
